import React from 'react'

type ArrowProps = {
  className?: string
  style?: React.CSSProperties
  onClick?: () => void
  direction: 'prev' | 'next'
}

export default function CustomArrow({
  className,
  style,
  onClick,
  direction,
}: ArrowProps) {

  return (
    <button
      className={className}
      style={{
        ...style,
        border: 'none',
        background: 'transparent',
        padding: 0,
        cursor: 'pointer',
   
      }}
      onClick={onClick}
      aria-label={direction === 'prev' ? 'Anterior' : 'Próximo'}
    >
      <svg
        width="33"
        height="33"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16.854" cy="16.1782" r="16" fill="black" />
        <path
          d="M14.7202 10.8447L20.0548 16.1793L14.7202 21.5114"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
    </button>
  )
}
